<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>帳號設定</f7-nav-title>
    </f7-navbar>

    <f7-block-title>帳號基本資料</f7-block-title>
    <f7-card>
      <f7-card-content :padding="false">
        <f7-list media-list>
          <f7-list-item title="顯示名稱:" link="/edit-display-name-prompt" :after="displayName" />
        </f7-list>
      </f7-card-content>
    </f7-card>

    <f7-block-title>帳號登入方式</f7-block-title>
    <f7-card>
      <f7-card-content :padding="false">
        <f7-list media-list v-if="providerData.length !== 0">
          <f7-list-item title="Email 帳號">
            <div slot="text">
              <div class="provider-data-row">
                <div>{{ email }}</div>
                <f7-link class="afterButton" href="/edit-email-form">修改</f7-link>
              </div>
              <template v-if="emailAccount">
                <div v-if="emailVerified" class="provider-data-row">
                  <div>狀態: 已認證</div>
                </div>
                <div v-else class="provider-data-row">
                  <div>狀態: Email 尚未認證</div>
                  <f7-link raised fill class="afterButton" @click="sendEmailVerificationOnClick">重新發送認證信</f7-link>
                </div>
              </template>
              <div v-else class="provider-data-row">
                <div>狀態: 未啟用</div>
                <f7-link raised fill slot="content" class="afterButton" href="/link-email-account-form">啟用</f7-link>
              </div>
            </div>
          </f7-list-item>

          <f7-list-item v-if="googleAccount" title="Google 帳號" :text="googleAccount.email">
            <f7-button v-if="providerData.length > 1" raised fill slot="content" @click="unlinkAccount(googleProviderId)" class="afterButton">關閉</f7-button>
          </f7-list-item>
          <f7-list-item v-else title="Google 帳號" text="關閉">
            <f7-button raised fill slot="content" @click="linkGoogleAccount" class="afterButton">啟用</f7-button>
          </f7-list-item>
        </f7-list>
      </f7-card-content>
    </f7-card>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      createEmailInput: null,
      createPasswordInput: null,
      emailProviderId: 'password',
      googleProviderId: 'google.com'
    }
  },
  computed: {
    ...mapState('userModule', ['displayName', 'email', 'providerData', 'emailVerified']),
    emailAccount () {
      return this.providerData.find(d => d.providerId === this.emailProviderId)
    },
    googleAccount () {
      return this.providerData.find(d => d.providerId === this.googleProviderId)
    }
  },
  methods: {
    ...mapActions('userModule', ['linkGoogleAccount', 'unlinkAccount', 'sendEmailVerification']),
    async sendEmailVerificationOnClick () {
      await this.sendEmailVerification()
      this.$f7.notification.create({
        title: '已送出',
        text: '請至所填的 Eamil 信箱點選認證信件內的連結',
        closeOnClick: true,
        closeButton: true
      }).open()
    }
  }
}
</script>

<style lang="scss" scoped>
.afterButton {
  margin: 0px 10px;
}
.provider-data-row {
   display: flex;
   justify-content: space-between;
}
</style>
